export class MaintenanceMode {
  active: boolean = false;
  startDate: number | null = null;
  endDate: number | null = null;
  message: string = "";
}
